import React, { Fragment } from 'react'
import Header from '../Components/HomeComponents/Headear/Header'
import Reservations from '../Components/UserComponents/Reservations/Reservations'

function ReservationPage() {
  return (
    <Fragment>
    <Header/>
    <Reservations/>
</Fragment>
  )
}

export default ReservationPage